<template lang="html">
    <section class="detail-orders">
        <div class="">
            <div class="row">
                <div class="col-md-8 col-xs-8">
                    <h1 class="title">Order #{{ this.$route.params.id }}</h1>
                    <span class="detail-created">
                        Created : {{ getOrdersDetail.createdAt }} {{ $t("planoList.by") }} {{ getOrdersDetail.createdBy.firstname }}
                        {{ getOrdersDetail.createdBy.lastname }}
                    </span>
                    <span class="detail-modify">
                        {{ $t("planoList.modified") }} : {{ getOrdersDetail.modifiedDate }} {{ $t("planoList.by") }}
                        {{ getOrdersDetail.modifiedBy.firstname }} {{ getOrdersDetail.modifiedBy.lastname }}
                    </span>
                </div>
                <div class="col-md-4 col-xs-4 page-prev">
                    <router-link class="btn btn-prev" :to="{ name: 'ListOrders' }">Retour list orders</router-link>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 col-xs-12 order-md-2 mb-4">
                    <div class="store-infos"><h2>Store Information</h2></div>
                </div>
                <div class="col-md-8 col-xs-12 order-md-1 detail-content">
                    <div v-if="showMsgDetails"><p style="color: red;">No response</p></div>
                    <div v-if="hideArray">
                        <p style="color: red;">Contactez votre admin, Error {{ getOrdersDetail.code }}</p>
                    </div>
                    <table class="table table-hover table-detail">
                        <thead>
                            <tr>
                                <th scope="col">ID</th>
                                <th scope="col">Description</th>
                                <th scope="col" style="text-align: center" width="100">Unit * QTY</th>
                                <th scope="col">Unit price</th>
                                <th scope="col">Total price</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td>{{ item.id }}</td>
                                <td>
                                    <router-link :to="{ path: '/module/' + item.id }"> {{ getTranslate(item.name).toLowerCase() }} </router-link>
                                </td>
                                <td style="text-align: center">{{ item.unit }} * {{ item.quantity }}</td>
                                <td>{{ item.price | currencyCustomPipe("en-US") }}</td>
                                <td>{{ item.totalPrice | currencyCustomPipe("en-US") }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'orders-detail',
    props: [],
    mounted () {
    },
    data () {
        return {
            objDetails: [],
            items: [],
            showMsgDetails: false,
            hideArray: false
        }
    },
    created () {
        this.detailOrders(this.$route.params.id).then(() => {
            if (typeof this.getOrdersDetail.items !== 'undefined' && this.getOrdersDetail.code !== 400) {
                this.showMsgDetails = false
                this.getOrdersDetail.items.map(v => {
                    this.items.push({
                        id: v.component.id,
                        price: (v.component.price !== null) ? v.component.price.value : '',
                        currency: (v.component.price !== null) ? v.component.price.currency.symbol : '',
                        shortName: (v.component.price !== null) ? v.component.price.currency.shortName : '',
                        totalPrice: (v.component.price !== null) ? v.component.price.value * v.quantity : '',
                        quantity: v.quantity,
                        unit: v.unit,
                        name: v.component.terms.name
                    })
                })
            } else if (this.getOrdersDetail.code === 400) {
                this.hideArray = true
            } else {
                this.showMsgDetails = true
            }
        })
    },
    methods: {
        ...mapActions({
            detailOrders: 'ordersStore/detailOrders'
        })
    },
    computed: {
        ...mapGetters({
            getOrdersDetail: 'ordersStore/getOrdersDetail'
        })
    }
}
</script>

<style scoped lang="scss">
.detail {
    &-orders {
        width: 100%;
        & .title {
            width: 100%;
            text-transform: uppercase;
            font-size: 15px;
            font-weight: normal;
            font-size: xx-large;
            margin-bottom: 10px;
            font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        }
        & .table {
            & thead {
                & th {
                    border: none;
                    background-color: #005f7f;
                    color: white;
                    text-transform: uppercase;
                    font-size: 13px;
                    padding: 1.1rem;
                    text-align: left;
                    &:first-child {
                        width: 50px;
                    }
                }
            }
            & tbody {
                & tr {
                    transition: all 0.3s ease;
                    -o-transition: all 0.3s ease;
                    -webkit-transition: all 0.3s ease;
                    border-bottom: 1px solid #e5e5e5;
                    background-color: #ffffff;
                    &:hover {
                        background-color: rgba(0, 0, 0, 0.05);
                        & td {
                            color: #343a40;
                            & a {
                                color: #343a40;
                            }
                        }
                    }
                }
                & td {
                    border: none;
                    padding-top: 20px;
                    padding-bottom: 20px;
                    text-align: left;
                    // text-transform: lowercase;
                    color: #6f6f6f;
                    & a {
                        color: #6f6f6f;
                        text-decoration: none;
                        &:hover {
                            text-decoration: underline;
                        }
                    }
                    & .btn-list {
                        color: #ffffff;
                        background: #005f7f;
                        padding: 5px 20px;
                        text-decoration: none;
                        &:hover {
                            background: #0085b2;
                        }
                    }
                }
            }
            &-detail {
                border-collapse: collapse;
                border-spacing: 0;
                border: 1px solid #005f7f;
                border-radius: 10px;
                overflow: hidden;
            }
        }
        & .store-infos {
            border: 1px solid #001319;
            margin-top: 10px;
            min-height: 200px;
            & h2 {
                background-color: #001319;
                color: #ffffff;
                text-transform: uppercase;
                margin-top: 0;
                padding: 1.1rem;
                font-size: 13px;
            }
        }
        & .page-prev {
            text-align: right;
            & .btn {
                &-prev {
                    position: relative;
                    top: 50%;
                    text-decoration: none;
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }
    &-content {
        margin-top: 10px;
        // border: 1px solid #005f7f;
        padding: 0;
    }
    &-created {
        font-size: 11px;
    }
    &-modify {
        font-size: 11px;
        margin-left: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// OrderDetail.vue?629de5c2